import React from "react";
import { Popup } from "../../../../Types";
import { useViewerPopupStore } from "../../../../state management/zustand/viewer-stores";

function youtube_parser(url: string): string | undefined {
  let regExp =
    /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
  let match = url.match(regExp);
  return match && match[7].length === 11 ? match[7] : undefined;
}

const OpenVideoPopup = () => {
  const { currentPopupContent } = useViewerPopupStore();
  const currentPop = currentPopupContent as Popup;

  return (
    <div className="content">
      <div
        style={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <iframe
          width="560"
          height="315"
          src={`https://www.youtube.com/embed/${youtube_parser(
            currentPop?.video!
          )}`}
          title="YouTube video player"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          style={{ maxWidth: "100%", left: "50%" }}
        ></iframe>
      </div>
      <p>{currentPop?.text}</p>
    </div>
  );
};

export default OpenVideoPopup;
